module.exports = __webpack_public_path__ + "static/img/nav_bg.657cdb02.png";